import MapLevel from '../../pages/map-level/MapLevel';

const MapResolver = () => {
  return <MapLevel />;
};

export default MapResolver;
